export default __webpack_public_path__ + "static/media/Politica de Cookies - Vai de Ferias - 22-03-2022.586e407d.pdf";